import amazonMusicIcon from '~/modules/artist-roster/components/TrackDetails/images/Amazon_Music_icon.svg?url';
import appleMusicIcon from '~/modules/artist-roster/components/TrackDetails/images/Apple_Music_icon.svg?url';
import spotifyIcon from '~/modules/artist-roster/components/TrackDetails/images/Spotify_icon.svg?url';
import tidalIcon from '~/modules/artist-roster/components/TrackDetails/images/Tidal_icon.svg?url';
import youtubeIcon from '~/modules/artist-roster/components/TrackDetails/images/YouTube_icon.svg?url';

interface DSPIconProps {
  type: string;
  className?: string;
}

export function DSPIcon({ type, className = '' }: DSPIconProps) {
  let src = null;

  if (type === 'spotify') {
    src = spotifyIcon;
  } else if (type === 'apple') {
    src = appleMusicIcon;
  } else if (type === 'amazon') {
    src = amazonMusicIcon;
  } else if (type === 'youtube') {
    src = youtubeIcon;
  } else if (type === 'tidal') {
    src = tidalIcon;
  }

  return src ? <img src={src} alt={type} className={className} /> : null;
}

DSPIcon.displayName = 'DSPIcon';
